import { createGlobalStyle } from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

export const GlobalStyle = createGlobalStyle`
  .ant-tabs {
    & .ant-tabs-tab {
      font-size: 14px;
      font-weight: 600;
      line-height: 19px;
      padding: 6px 3px;

      & .ant-tabs-tab-btn {
        display: flex;
        align-items: center;

        & svg {
          margin-right: 8px;
          margin-left: -2px;

          &.active {
            display: none;
          }

          & .color-fill {
            fill: ${colors.lightGrey} !important;
          }

          & .color-stroke {
            stroke: ${colors.lightGrey} !important;
          }
        }
      }

      &.ant-tabs-tab-active {
        & .ant-tabs-tab-btn {
          & svg {
            display: none;

            &.active {
              display: inline;
            }

            & .color-fill {
              fill: ${colors.waterBlue} !important;
            }

            & .color-stroke {
              stroke: ${colors.waterBlue} !important;
            }
          }        
        }
      }
    }
  }

  .ant-table-wrapper {
    &.rows-selectable {
      & tbody {
        & td {
          cursor: pointer;
        }
      }
    }

    & ul.ant-table-pagination {

    }
  }

  .ant-table {
    table {
      table-layout: fixed !important;
      border-collapse: collapse;
    }

    & .ant-table-thead {
      & .ant-table-cell {
        line-height: 19px;
        background: transparent;
        border-bottom: 1px solid ${colors.lightGrey};
        padding: 8px 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    & .ant-table-tbody {
      & .ant-table-placeholder {
        & .ant-table-cell {
          border-bottom: none;
        }
      }

      & .ant-table-row {
        & td.ant-table-cell {
          line-height: 44px;
          color: ${colors.steelGrey};
          border-bottom: 1px solid ${colors.lightGrey};
          padding: 2px 16px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          & > img {
            max-width: 100%;
          }
        }

        &.ant-table-row-selected {
          border-top: 5px solid white;
          border-bottom: 5px solid white;

          & td.ant-table-cell {
            background: ${colors.footerColor};
            border-bottom: none;
            padding: 0 16px;

            &:first-child {
              border-radius: 0 0 4px 4px;
            }
          }
        }
      }
    }
  }

  .ant-notification {
    @media (max-width: ${measures.mobileThreshold}px) {
      width: 100%;
      margin-right: 0;
      top: 0 !important;
    }
  }

  .ant-notification-notice.error-popup {
    background: ${colors.reddishPink};
    color: white;
    border-radius: 4px;
    padding: 12px 22px 12px 16px;
    box-shadow: none;
    display: flex;
    align-items: center;

    @media (max-width: ${measures.mobileThreshold}px) {
      width: 100%;
      max-width: 100%;
      border-radius: 0;
      padding: 12px 28px 12px 24px;
    }

    & > .ant-notification-notice-content {
      flex: 1;

      & > .ant-notification-notice-with-icon {
        display: flex;
        align-items: center;

        & > .ant-notification-notice-icon {
          position: relative;
          margin: 0;
        }

        & > .ant-notification-notice-message {
          line-height: 16px;
          color: white;
          font-size: 12px;
          margin: 0 15px;
          padding: 0;
          flex: 1;

          @media (max-width: ${measures.mobileThreshold}px) {
            margin: 0 22px;
          }
        }

        & > .ant-notification-notice-description {
          display: none;
        }
      }
    }

    & > .ant-notification-notice-close {
      position: relative;
      top: 0;
      right: 0;
    }

    & svg .color-stroke {
      stroke: white;
    }
  }
  .ant-notification-notice.success-popup {
    background: ${colors.blueGreen};
    color: white;
    border-radius: 4px;
    padding: 12px 22px 12px 16px;
    box-shadow: none;
    display: flex;
    align-items: center;

    @media (max-width: ${measures.mobileThreshold}px) {
      width: 100%;
      max-width: 100%;
      border-radius: 0;
      padding: 12px 28px 12px 24px;
    }

    & > .ant-notification-notice-content {
      flex: 1;

      & > .ant-notification-notice-with-icon {
        display: flex;
        align-items: center;

        & > .ant-notification-notice-icon {
          position: relative;
          margin: 0;
        }

        & > .ant-notification-notice-message {
          line-height: 16px;
          color: white;
          font-size: 12px;
          margin: 0 15px;
          padding: 0;
          flex: 1;

          @media (max-width: ${measures.mobileThreshold}px) {
            margin: 0 22px;
          }
        }

        & > .ant-notification-notice-description {
          display: none;
        }
      }
    }

    & > .ant-notification-notice-close {
      position: relative;
      top: 0;
      right: 0;
    }

    & svg .color-stroke {
      stroke: white;
    }
  }

  h4 {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
`
